import { render, staticRenderFns } from "./ClinicHealthEducationSharing.vue?vue&type=template&id=2b104a84&scoped=true"
import script from "./ClinicHealthEducationSharing.vue?vue&type=script&lang=js"
export * from "./ClinicHealthEducationSharing.vue?vue&type=script&lang=js"
import style0 from "./ClinicHealthEducationSharing.vue?vue&type=style&index=0&id=2b104a84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b104a84",
  null
  
)

export default component.exports